import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { UserProvider } from "./context/UserContext";
import { GuidedSetupBusinessProvider } from "./context/GuidedSetupBusinessContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserProvider>
      <GuidedSetupBusinessProvider>
        <App />
      </GuidedSetupBusinessProvider>
    </UserProvider>
  </React.StrictMode>
);

reportWebVitals();
